export const actions = {
    LOGIN_REQUEST: 'LOGIN_REQUEST',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAILURE: 'LOGIN_FAILURE',

    UPDATE_FORM_DATA: 'UPDATE_FORM_DATA',
    CLEAR_FORM_DATA: 'CLEAR_FORM_DATA',
}